<template>
  <div>
    <b-row>
      <b-col cols="12">
        <div
          class="d-flex justify-content-between align-items-center pt-50 mb-2"
        >
          <div>
            <h2 class="font-weight-bolder m-0">
              Departamentos
            </h2>
          </div>
          <div class="d-flex align-items-center">
            <div>
              <b-link :to="{ name: 'createDepartment' }">
                <b-button
                  variant="primary"
                  class="mr-1 text-nowrap"
                >
                  {{ "Añadir nuevo departamento" }}
                </b-button>
              </b-link>
            </div>
            <b-input-group class="input-group">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input
                v-model="searchTerm"
                type="text"
                class="d-inline-block"
                :placeholder="'Búsqueda'"
                @keydown.enter.native="handleSearch"
              />
              <b-button
                variant="primary"
                class="mr-1 ml-1"
                @click="handleSearch"
              >
                {{ "Buscar" }}
              </b-button>
            </b-input-group>
          </div>
        </div>
        <b-card no-body>
          <b-table
            hover
            responsive
            :items="items"
            :fields="columns"
          >
            <template #cell(active)="data">
              <b-badge
                v-if="data.item.active"
                variant="light-success"
              >
                ACTIVO
              </b-badge>
              <b-badge
                v-else
                variant="light-danger"
              >
                DESACTIVO
              </b-badge>
            </template>
            <template #cell(actions)="data">
               <span
                   variant="primary"
                   @click.prevent="downloadItem(data.item.id, 'archivo-qr')">
                  <img
                      src="/img/qr-code-solid.svg"
                      alt="QR Code Icon"
                  >
                </span>
              <span>
                <b-link
                  :to="{ name: 'editDepartment', params: { id: data.item.id } }"
                  class="d-inline-block px-50 text-dark"
                >
                  <feather-icon icon="Edit2Icon" />
                </b-link>
                <span
                  class="d-inline-block px-50 text-danger"
                  @click="deleteDepartment(data.item.id, data.item.name)"
                >
                  <feather-icon icon="TrashIcon" />
                </span>
              </span>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import {
  BFormInput,
  BBadge,
  BLink,
  BButton,
  BCard,
  BTable,
  BCol,
  BRow,
  BInputGroup,
  BInputGroupPrepend,
} from 'bootstrap-vue'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import store from '@/store/index'
import { config } from '@/shared/app.config'

export default {
  components: {
    BCard,
    BFormInput,
    BBadge,
    BTable,
    BButton,
    BCol,
    BRow,
    BLink,
    BInputGroup,
    BInputGroupPrepend,
  },
  data() {
    return {
      log: [],
      dir: false,
      columns: [
        {
          label: 'Nombre',
          key: 'name',
        },
        {
          label: 'Estado',
          key: 'active',
        },
        {
          label: 'Acciones',
          key: 'actions',
          class: 'column-actions',
        },
      ],
      searchTerm: '',
    }
  },
  computed: {
    ...mapGetters({
      items: 'departments/getItems',
      totalItems: 'departments/getTotalItems',
      currentClient: 'clients/getCurrentClient'
    }),
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {
    this.chargeData()
  },
  methods: {
    ...mapActions({
      list: 'departments/getListDepartments',
      delete: 'departments/delete',
    }),
    downloadItem(url, label) {
      axios.get(`${config.webApiBase}/getqr/${url}`, { responseType: 'blob' })
          .then(response => {
            const blob = new Blob([response.data], { type: 'application/pdf' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = label
            link.click()
            URL.revokeObjectURL(link.href)
          }).catch(console.error)
    },
    chargeData() {
      this.list({
        page: this.currentPage,
        per_page: this.pageLength,
        search: this.searchTerm,
        client_id: this.currentClient.id
      })
    },
    handleSearch() {
      this.currentPage = 1
      this.chargeData()
    },
    handleChangePage(page) {
      this.currentPage = page
      this.chargeData()
    },
    handlePageChange() {
      this.currentPage = 1
      this.chargeData()
    },
    onSortChange(params) {
      this.currentPage = 1
      this.chargeData()
    },
    deleteDepartment(id, name) {
      this.$bvModal
        .msgBoxConfirm(`¿Estás seguro de eliminar ${name}?`, {
          bodyClass: 'bodyDelete',
          footerClass: 'footerDelete',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'outline-danger',
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.delete(id)
          }
        })
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
